
const HeroSection = () => {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0b1e371b2f47d3e8ad0ec94e13df2753.jpg"
          alt="خياط الأقمشة الكويتية"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white px-6 max-w-4xl mx-auto">
        <h1 className="text-6xl md:text-7xl font-bold mb-6">
          خياط الأقمشة الكويتية
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-gray-100">
          أجود أنواع الأقمشة المستوردة مع تفصيل احترافي يليق بذوقك الرفيع
        </p>
        <div className="flex gap-4 justify-center flex-wrap">
          <a
            href="/fabrics"
            className="bg-secondary text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-opacity-90 transition-all cursor-pointer whitespace-nowrap"
          >
            تصفح الأقمشة
          </a>
          <a
            href="/tailoring"
            className="bg-white text-accent px-8 py-4 rounded-full text-lg font-medium hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
          >
            طلب تفصيل
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
